import { defineComponent } from 'vue';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import { passwordRule } from '@/helpers/ValidationRules';
export default defineComponent({
    name: 'base-password-input',
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: 'Passwort',
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Wähle Dein Passwort',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Array,
            default: null,
        },
    },
    emits: ['changed', 'update:modelValue'],
    components: {
        BaseInput,
    },
    data() {
        return { show_password: false };
    },
    computed: {
        passwordValue: {
            get() {
                return this.modelValue;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
        inputFieldType() {
            return this.isPasswordVisible ? 'text' : 'password';
        },
        rule() {
            return passwordRule;
        },
        passwordActionImage() {
            return this.isPasswordVisible ? 'images/icons/password-show.svg' : 'images/icons/password-hide.svg';
        },
        passwordActionTitle() {
            return this.isPasswordVisible ? 'Passwort ausblenden' : 'Passwort einblenden';
        },
        isPasswordVisible() {
            return !this.disabled && !this.readonly && this.show_password;
        },
    },
    methods: {
        toggleShowPassword() {
            this.show_password = !this.show_password;
        },
        handleChangedEvent(event) {
            this.$emit('changed', event);
        },
    },
});
